'use client'
import { ChainEnum } from '@dynamic-labs/sdk-api-core';
import { MULTI_ASSET_SUPPORTED_NETWORKS } from './constants.js';

const isMultiAssetSupportedNetwork = (walletConnector, network) => {
    const isNetworkMultiAssetSupported = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === ChainEnum.Sol ||
        ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === ChainEnum.Evm &&
            typeof network === 'number' &&
            MULTI_ASSET_SUPPORTED_NETWORKS.includes(network));
    return Boolean(isNetworkMultiAssetSupported);
};

export { isMultiAssetSupportedNetwork };
